// import { useQuery } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ttsService } from '../services/textToSpeechApi';

export function useVoices() {
  return useQuery({
    queryKey: ['ttsvoices'],
    queryFn: async () => {
      try {
        const data = await ttsService.getAllVoices();
        const males = data.data.filter(
          (item: { gender: string }) => item.gender === 'Male'
        );
        const females = data.data?.filter(
          (item: { gender: string }) => item.gender === 'Female'
        );

        return {
          male: males,
          female: females,
        };
      } catch (error) {
        if (axios.isAxiosError(error)) {
          throw new Error(error.response?.data?.message || 'An error occurred');
        }
        throw error;
      }
    },
  });
}
